import { Api } from '@/services/Api'
import store from "@/store/index";
const momentTz = require('moment-timezone')

export default {
  getOverallHeader(plantId) {
    return Api().get(`/api/v2/inverter-ranking/overall-performance/${plantId}`)
  },
  getRankingHeader(plantId, parameter) {
    return Api().get(`/api/v2/inverter-ranking/ranking-trend/${plantId}/${parameter}`)
  },
  getPrPerformance(plantId) {
    return Api().get(`/api/v2/inverter-ranking/best-pr/${plantId}`)
  },
  getTableData(param) {
    return Api().post(`/api/v2/inverter-ranking/table`, param)
  },
  getHeatMapRank(param) {
    return Api().post(`/api/v2/inverter-ranking/heatmap`, param)
  },
  downloadReport(param, name) {
    return Api().request({
      url: '/api/v2/inverter-ranking/download/' + param,
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      const tz = store.getters.getActivePlantInfo('timezone')
      link.href = url
      link.setAttribute('download', `${name}-${momentTz().tz(tz).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  }
}
